<aura-edit-wrapper
  title="Secteur d'intervention"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  [showDivider]="true"
  (saved)="onSave($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <etxe-agent-zones-form
      [primaryRegion]="currentPrimaryRegion()"
      [interventionZones]="currentInterventionZones()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <etxe-agent-zones-display
      [primaryRegion]="currentPrimaryRegion()"
      [interventionZones]="currentInterventionZones()"
    />
  }
</aura-edit-wrapper>
